import React, { Component } from 'react';
import { BotBubbleSvg } from '../utils/svg-icons-24';

class BotMessageText extends Component{
    constructor(props){
        super(props);
    }
    render(){
        const { isIcon=false, classN, children, botTitle } = this.props;
        // console.log(this.props.children);
        return(
            <div className={`message message-operator ${classN}`}>
                {isIcon && <i className="conv-icon">
                    <BotBubbleSvg />
                    <span>{botTitle}</span>
                </i>}
                {classN==='message-hellonce' && <span className="message-bot-image"></span>}
                <span className="message-content">{children}</span>
            </div>        
        )
    }
}
BotMessageText.propTypes = {
    children: React.propTypes.node,
    classN: React.propTypes.node,
}
export default BotMessageText;